// src/pages/SwitchesPage.jsx

import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import PageHeader from "../components/ui/PageHeader";
import SwitchList from "../components/switches/SwitchList";
import SwitchForm from "../components/switches/SwitchForm";

const SwitchesPage = () => {
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingSwitch, setEditingSwitch] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleEdit = (switchItem) => {
    setEditingSwitch(switchItem);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingSwitch(null);
    setRefreshKey((k) => k + 1);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingSwitch(null);
  };

  return (
    <Box>
      <PageHeader
        title="Trámites"
        subtitle="Gestión de trámites de cambio de comercializadora"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingSwitch(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nuevo Trámite
          </Button>
        }
      />

      <SwitchList key={refreshKey} onEdit={handleEdit} />

      <Dialog
        open={showForm}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: "24px" } }}
      >
        <DialogContent sx={{ p: 0 }}>
          <SwitchForm
            switchItem={editingSwitch}
            onSave={handleSave}
            onCancel={handleClose}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SwitchesPage;